import React, { useState } from "react";
import Products from "../components/Products";
import { FiTrash, FiEdit } from "react-icons/all";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";

import IconButton from "@material-ui/core/IconButton";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Divider from "@material-ui/core/Divider";
import { pink, green } from "@mui/material/colors";
import { deleteAProducts } from "../Data/Products";
import { FStorage, firebase_Db } from "../config/firebaseConfig";

const DBName = "products";

const ProductListComponent = ({ products }) => {
  const { data, id } = products;
  const [openEditComponent, setOpenEditComponent] = useState(false);

  return (
    <div>
      <List>
        <ListItem>
          <ListItemAvatar>
            <Avatar
              alt="Remy Sharp"
              src={data.imgUrl}
              sx={{ width: 100, height: 100 }}
              className="productlist_avatar"
            />
          </ListItemAvatar>
          <ListItemText
            primary={data.name}
            secondary={`Ghc${data.price}`}
            className="productlist_ItemText"
          />
          <ListItemText
            primary={`category: ${data.category}`}
            secondary={`subCategory: ${data.subCategory}`}
          />
          <ListItemText primary={`Desc: ${data.description.slice(0, 100)}`} />
          <ListItemSecondaryAction>
            <IconButton
              edge="end"
              aria-label="delete"
              onClick={async (_) => {
                deleteAProducts(id);
                alert("Product Deleted");
              }}
            >
              <DeleteIcon color="error" fontSize="large" />
            </IconButton>
            <IconButton
              edge="end"
              aria-label="edit"
              onClick={() => setOpenEditComponent(!openEditComponent)}
            >
              <EditIcon color="primary" fontSize="large" />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </List>

      {openEditComponent && (
        <Products
          btnName="Update"
          titleName="Edit product"
          submitType="Update"
          productData={products}
        />
      )}
      <Divider dark />
    </div>
  );
};

export default ProductListComponent;

// <ul className="productlist">
//   <li className="listitem">
//     <div className="img">
//       <img src={data.imgUrl} className="listitem-img" alt="" />
//     </div>
//     <div className="productInfo">
//       <h3>{data.name}</h3>
//       <h4>{data.price}</h4>
//       <p>{data.description}</p>
//       <h5>
//         {data.category}, {data.subCategory}
//       </h5>
//     </div>
//     <div className="btn-container1">
//       <button
//         className="edit-btn"
//         onClick={() => setOpenEditComponent(!openEditComponent)}
//       >
//         Edit <FiEdit />
//       </button>
//       <button className="del-btn">
//         Delete <FiTrash />
//       </button>
//     </div>
//     {openEditComponent && (
//       <Products btnName="Update" titleName="Edit product" />
//     )}
//   </li>
// </ul>
